import { useEffect, useRef } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export default function PostcardViewer3D({ frontCanvas, backCanvas }) {
    const mountRef = useRef(null);

    useEffect(() => {
        if (!frontCanvas || !backCanvas || !mountRef.current) return;

        const mount = mountRef.current;
        const width = mount.clientWidth;
        const height = mount.clientHeight;

        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 100);
        camera.position.set(0, 0, 4.2);

        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setSize(width, height);
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setClearColor(0x000000, 0);
        mount.appendChild(renderer.domElement);

        scene.add(new THREE.AmbientLight(0xffffff, 0.9));
        const key = new THREE.DirectionalLight(0xffffff, 0.6);
        key.position.set(2, 3, 4);
        scene.add(key);

        const cardW = 3;
        const cardH = cardW * (800 / 1200);
        const cardDepth = 0.02;
        const geometry = new THREE.BoxGeometry(cardW, cardH, cardDepth);

        const frontTexture = new THREE.CanvasTexture(frontCanvas);
        const backTexture = new THREE.CanvasTexture(backCanvas);
        frontTexture.colorSpace = THREE.SRGBColorSpace;
        backTexture.colorSpace = THREE.SRGBColorSpace;

        const edgeMaterial = new THREE.MeshStandardMaterial({ color: 0xe9dfc7 });

        const materials = [
            edgeMaterial,
            edgeMaterial,
            edgeMaterial,
            edgeMaterial,
            new THREE.MeshBasicMaterial({ map: frontTexture }),
            new THREE.MeshBasicMaterial({ map: backTexture }),
        ];

        const card = new THREE.Mesh(geometry, materials);
        scene.add(card);

        const controls = new OrbitControls(camera, renderer.domElement);
        controls.enableDamping = true;
        controls.dampingFactor = 0.08;
        controls.enablePan = false;
        controls.minDistance = 2.5;
        controls.maxDistance = 7;
        controls.rotateSpeed = 0.6;

        let frameId;
        const animate = () => {
            frameId = requestAnimationFrame(animate);
            frontTexture.needsUpdate = true;
            backTexture.needsUpdate = true;
            controls.update();
            renderer.render(scene, camera);
        };
        animate();

        const handleResize = () => {
            const w = mount.clientWidth;
            const h = mount.clientHeight;
            camera.aspect = w / h;
            camera.updateProjectionMatrix();
            renderer.setSize(w, h);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            cancelAnimationFrame(frameId);
            window.removeEventListener("resize", handleResize);
            controls.dispose();
            renderer.dispose();
            geometry.dispose();
            frontTexture.dispose();
            backTexture.dispose();
            edgeMaterial.dispose();
            mount.removeChild(renderer.domElement);
        };
    }, [frontCanvas, backCanvas]);

    return (
        <div
            ref={mountRef}
            style={{ width: "100%", maxWidth: 720, height: 480, margin: "0 auto", cursor: "grab" }}
        />
    );
}